// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_2gTv4","visuallyhidden":"_2DPmu","hide-text":"rgK8k","center":"_3QP5Z","noprint":"_1j0f3","badgeWrapper":"_3at7q","badge-userMenu":"_3VL_B","badgeWrapper-Open":"_1t6fF","badge-mastheadExtension":"_258aR","iconWrapper":"_1BQbD","familyName":"_31zkq","subscriptionLabel":"_3UJOB","userDescription":"eTciG","logoutButton":"_2goCo"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/cn-skin-vg/styles/components/LoggedInBadge.scss
 ** module id = 960
 ** module chunks = 1
 **/